import React, {Component} from 'react';
import Loading from "../Common/Loading";
import Actionbar from "../Common/Actionbar";
import API from "../../services/API";
import {FaRegUserCircle, IoCarSport} from "react-icons/all";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";

class ManageUsers extends Component {
    state = {
        cars: [],
        isLoaded: false,
        activeCar: window.localStorage.getItem("_ac" ),
        phone1: '',
        phone2: '',
        phone3: '',
        phone4: '',
    }

    onInputChange = (val) => {
        const mobile = val.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile.length > 2 && (mobile[0] !== '0' || mobile[1] !== '9')) {
            toast.error('شماره موبایل بایستی با ۰۹ با اعداد انگلیسی شروع شود. شماره موبایل کاربر را درست وارد کنید. ');
            return false;
        }
        const inputName = val.target.name;
        this.setState({[inputName]: mobile});
    }

    sendToSocket = (command) => {
        const ConnectionType = window.localStorage.getItem("connection_type");
        if(ConnectionType === 'internet') {
            const request = {
                'mobile': this.state.cars[this.state.activeCar].main_phone,
                'device': this.state.cars[this.state.activeCar].car_code,
                'password': window.localStorage.getItem("password"),
                'command': command
            };
            this.setState({isLoaded: false})
            API.socketSendData(request)
                .then((response) => {
                    toast.success('دستور با موفقیت به دستگاه ارسال شد')
                    this.setState({isLoaded: true})
                })
        }
        else {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(!check) {
                toast.error('شما در حال استفاده در کامپیوتر هستید، امکان ارسال پیامک با استفاده از کامپیوتر وجود ندارد. لطفا نحوه ارتباط را به حالت اینترنتی تغییر دهید ');
                return false;
            }
            let body = '*' + command.replace('-','*') + '#';

            if (navigator.userAgent.match(/Android/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

            }
            if (navigator.userAgent.match(/iPhone/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
            }
        }

    }

    render() {
        return (
            <React.Fragment>
                {
                    !this.state.isLoaded && <Loading/>
                }
                <Actionbar title='مدیریت کاربران' noBack={0}/>
                <Toast/>

                <section className="container mt-5 rtl ">
                    <div className="row pt-4">
                        <div className="col-12">
                            <div className='car-name '>
                                <IoCarSport className='ms-2 '/>
                                <select id="car-list-select"
                                        value= {this.state.activeCar}
                                        onChange={
                                            (val) => {
                                                this.setState({'activeCar': parseInt(val.target.value)})
                                                this.setState({
                                                    'phone1': this.state.cars[parseInt(val.target.value)].phone1 ,
                                                    'phone2': this.state.cars[parseInt(val.target.value)].phone2 ,
                                                    'phone3': this.state.cars[parseInt(val.target.value)].phone3,
                                                    'phone4': this.state.cars[parseInt(val.target.value)].phone4 ,
                                                })
                                            }
                                        }
                                >
                                    {
                                        this.state.cars.map((car, index) => {

                                            return (
                                                <option className="row transaction-item" key={car.car_code}
                                                        value={index}>
                                                    {car.car_name}
                                                    &nbsp;
                                                    (

                                                    {car.car_code}

                                                    )

                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>

                        </div>
                    </div>
                    <div className="row mt-2 transaction-item mx-0">
                        <div className="col-12">
                            <div className="form-floating mb-3">
                                <input type="tel" className="form-control user-phone"
                                       id="phone1" name="phone1"
                                       onChange={this.onInputChange}
                                       value={this.state.phone1}
                                       placeholder="شماره تلفن"/>
                                <label htmlFor="floatingInput"
                                       className='text-light  right-0 text-small-3 pr-0 user-phone-label'>
                                    <FaRegUserCircle className="ms-2"/>
                                    شماره تلفن
                                    کاربر شماره 1
                                </label>
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6">
                                    <button className="btn btn-success w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const value = this.state.phone1;
                                                    if (value.length === 11) {
                                                        const command = `mob1-${value}`;
                                                        this.sendToSocket(command);
                                                    }
                                                    else {
                                                        toast.error('موبایل را به صورت کامل وارد کنید')
                                                    }

                                                }
                                            }
                                    >
                                        افزودن کاربر
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button className="btn btn-danger w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const command = `mob1-del`;
                                                    this.sendToSocket(command);
                                                    this.setState({'phone1' : '0'})
                                                }
                                            }
                                    >
                                        حذف کاربر
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2 transaction-item mx-0">
                        <div className="col-12">
                            <div className="form-floating mb-3">
                                <input type="tel" className="form-control user-phone"
                                       id="phone2" name="phone2"
                                       onChange={this.onInputChange}
                                       value={this.state.phone2}
                                       placeholder="شماره تلفن"/>
                                <label htmlFor="floatingInput"
                                       className='text-light  right-0 text-small-3 pr-0 user-phone-label'>
                                    <FaRegUserCircle className="ms-2"/>
                                    شماره تلفن
                                    کاربر شماره 2
                                </label>
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6">
                                    <button className="btn btn-success w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const value = this.state.phone2;
                                                    if (value.length === 11) {
                                                        const command = `mob2-${value}`;
                                                        this.sendToSocket(command);
                                                    }
                                                    else {
                                                        toast.error('موبایل را به صورت کامل وارد کنید')
                                                    }

                                                }
                                            }
                                    >
                                        افزودن کاربر
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button className="btn btn-danger w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const command = `mob2-del`;
                                                    this.sendToSocket(command);
                                                    this.setState({'phone2' : '0'})
                                                }
                                            }
                                    >
                                        حذف کاربر
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2 transaction-item mx-0">
                        <div className="col-12">
                            <div className="form-floating mb-3">
                                <input type="tel" className="form-control user-phone"
                                       id="phone3" name="phone3"
                                       onChange={this.onInputChange}
                                       value={this.state.phone3}
                                       placeholder="شماره تلفن"/>
                                <label htmlFor="floatingInput"
                                       className='text-light  right-0 text-small-3 pr-0 user-phone-label'>
                                    <FaRegUserCircle className="ms-2"/>
                                    شماره تلفن
                                    کاربر شماره 3
                                </label>
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6">
                                    <button className="btn btn-success w-100 mt-3 text-small-1"         onClick={
                                        () => {
                                            const value = this.state.phone3;
                                            if (value.length === 11) {
                                                const command = `mob3-${value}`;
                                                this.sendToSocket(command);
                                            }
                                            else {
                                                toast.error('موبایل را به صورت کامل وارد کنید')
                                            }

                                        }
                                    }
                                    >
                                        افزودن کاربر
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button className="btn btn-danger w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const command = `mob3-del`;
                                                    this.sendToSocket(command);
                                                    this.setState({'phone3' : '0'})
                                                }
                                            }
                                    >
                                        حذف کاربر
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2 transaction-item mx-0">
                        <div className="col-12">
                            <div className="form-floating mb-3">
                                <input type="tel" className="form-control user-phone"
                                       id="phone4" name="phone4"
                                       onChange={this.onInputChange}
                                       value={this.state.phone4}
                                       placeholder="شماره تلفن"/>
                                <label htmlFor="floatingInput"
                                       className='text-light  right-0 text-small-3 pr-0 user-phone-label'>
                                    <FaRegUserCircle className="ms-2"/>
                                    شماره تلفن
                                    کاربر شماره 4
                                </label>
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-6">
                                    <button className="btn btn-success w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const value = this.state.phone4;
                                                    if (value.length === 11) {
                                                        const command = `mob4-${value}`;
                                                        this.sendToSocket(command);
                                                    }
                                                    else {
                                                        toast.error('موبایل را به صورت کامل وارد کنید')
                                                    }

                                                }
                                            }
                                    >
                                        افزودن کاربر
                                    </button>
                                </div>
                                <div className="col-6">
                                    <button className="btn btn-danger w-100 mt-3 text-small-1"
                                            onClick={
                                                () => {
                                                    const command = `mob4-del`;
                                                    this.sendToSocket(command);
                                                    this.setState({'phone4' : '0'})
                                                }
                                            }
                                    >
                                        حذف کاربر
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }

    componentDidMount = () => {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        if(!mobile && !password ) {
            window.location.replace('/')
        }

        API.getCarData(mobile,password)
            .then((response) => {

                this.setState({
                    isLoaded: true,
                    'cars': response.car_act,
                    'phone1': response.car_act[this.state.activeCar].phone1 ,
                    'phone2': response.car_act[this.state.activeCar].phone2 ,
                    'phone3': response.car_act[this.state.activeCar].phone3,
                    'phone4': response.car_act[this.state.activeCar].phone4 ,
                })
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default ManageUsers;